import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { transient } from "aurelia-dependency-injection";
import { autoinject } from "aurelia-framework";
import { ChangeLegacyCwsaStatusRequest, ChangeLegacyCwsaStatusResponse, GetLegacyCwsaPdfLinkResponse, GetLegacyCwsaResponse, SendLegacyCwsaEmailRequest, SendLegacyCwsaEmailResponse } from "../../models/cwsa/cwsa.models";

@autoinject()
@transient()
export class LegacyCwsaService {

    private _legacyCwsaApi: string = `${this.configService.config.urls.crewWelfareApiUrl}/api/v1/LegacyCrewWelfareSelfAssessment`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }

    public getPdfLink(legacyCwSelfAssessmentId: number): Promise<GetLegacyCwsaPdfLinkResponse> {
        return this.requestClientService.get(`${this._legacyCwsaApi}/GetPdfLink/${legacyCwSelfAssessmentId}`, {});
    }

    public getLegacyCwsa(legacyCwSelfAssessmentId: number): Promise<GetLegacyCwsaResponse> {
        return this.requestClientService.get(`${this._legacyCwsaApi}/GetLegacyCwsa/${legacyCwSelfAssessmentId}`, {});
    }

    public sendEmail(request: SendLegacyCwsaEmailRequest): Promise<SendLegacyCwsaEmailResponse> {
        return this.requestClientService.post(`${this._legacyCwsaApi}/SendEmail`, {}, request);
    }

    public changeStatus(request: ChangeLegacyCwsaStatusRequest): Promise<ChangeLegacyCwsaStatusResponse> {
        return this.requestClientService.post(`${this._legacyCwsaApi}/ChangeStatus`, {}, request);
    }
}